import { createContext } from "svelte";
import type { AuthSession } from "@supabase/supabase-js";

export const [getSessionContext, setSessionContext] = createContext<
  () => {
    profile: unknown;
    session: AuthSession | null;
  }
>();
